import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAppNote, IRealEstate } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getAppNoteList = (data: IDynamicTableParams) => {
  return instance()
    .post<IAppNote[]>('/app/note/list', data)
    .then((response) => response.data);
};

export const getAppNoteListAll = () => {
  return instance()
    .post<IAppNote[]>('/app/note/listAll')
    .then((response) => response.data);
};

export const getAppNoteAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/app/note/availableColumns')
    .then((response) => response.data);
};

export const getAppNoteAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/app/note/availableGroupColumns')
    .then((response) => response.data);
};

export const loadAppNote = (appNoteId: number) => {
  return instance()
    .get<IAppNote>(`/app/note/load/${appNoteId}`)
    .then((response) => response.data);
};

export const createAppNote = (appNote: IAppNote) => {
  return instance()
    .post<IAppNote>(`/app/note/save`, appNote)
    .then((response) => response.data);
};

export const updateAppNote = (appNote: IAppNote) => {
  return instance()
    .post<IAppNote>(`/app/note/${appNote.noteId}/update`, appNote)
    .then((response) => response.data);
};

export const archiveAppNote = (noteId: number) => {
  return instance()
    .post('/app/note/archive', { noteId })
    .then((response) => response.data);
};

export const recoverAppNote = (noteId: number) => {
  return instance()
    .post('/app/note/recover', { noteId })
    .then((response) => response.data);
};

// Dictionaries
export const getRealEstatesShort = (
  data: { includeUnserved?: boolean; includeDeleted?: boolean; searchWithCity?: boolean; nameWithCity?: boolean } = {
    includeUnserved: true,
    includeDeleted: true,
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};
